module.exports = __webpack_public_path__ + "images/connexxion_smallee08c62b77d938dbe66863e97f139d24.png";